import * as XLSX from "xlsx";

interface ExportOptions {
  data: any[];
  filename: string;
  sheetName?: string;
  maxColumnWidth?: number;
}

/**
 * Common utility function to export data to Excel
 * Handles column width calculation and file generation
 * @param options - Export configuration object
 */
export const exportToExcel = (options: ExportOptions): void => {
  const {
    data,
    filename,
    sheetName = "Report",
    maxColumnWidth = 25,
  } = options;

  if (data.length === 0) return;

  // Create worksheet from data
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Create workbook and append worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Calculate and set column widths
  const columnWidths = Object.keys(data[0] || {}).map((key) => ({
    wch: Math.min(
      Math.max(
        key.length,
        ...data.map((row: any) => String(row[key]).length)
      ),
      maxColumnWidth
    ),
  }));
  worksheet["!cols"] = columnWidths;

  // Generate filename with current date
  const date = new Date().toISOString().split("T")[0];
  const finalFilename = `${filename}_${date}.xlsx`;

  // Write and download file
  XLSX.writeFile(workbook, finalFilename);
};
